/**
 * This file gets loaded when we are operating within a "XB" environment.
 * The XB environment comes from coming from the XB flow and transitioning to '/transfer/send/external/xb', which redirects to the preview page.
 */

export default {
  initializeHook() {
    // HACK: When we transition from the xb flow and deep dive to the p2p review page, siteCatalyst fires off a beacon with 'pageName=main:consumer:p2p:transfer:send:start'.
    // This would mess up metrics as we aren't on the start of the flow. This hack fixes that on the review page.
    if (window.s) {
      window.s.pageName = 'main:consumer:p2p:transfer:xb:review'
    }
  },
}
